/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { TranchedPool, TranchedPoolInterface } from "../TranchedPool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract ICreditLine",
        name: "oldCreditLine",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract ICreditLine",
        name: "newCreditLine",
        type: "address",
      },
    ],
    name: "CreditLineMigrated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DrawdownMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "DrawdownsPaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "DrawdownsUnpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "EmergencyShutdown",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "payer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "principal",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reserve",
        type: "uint256",
      },
    ],
    name: "PaymentApplied",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ReserveFundsCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "principalSharePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "principalDelta",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestSharePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "interestDelta",
        type: "int256",
      },
    ],
    name: "SharePriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sliceId",
        type: "uint256",
      },
    ],
    name: "SliceCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "trancheId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lockedUntil",
        type: "uint256",
      },
    ],
    name: "TrancheLocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestWithdrawn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "principalWithdrawn",
        type: "uint256",
      },
    ],
    name: "WithdrawalMade",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LOCKER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NUM_TRANCHES_PER_SLICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SENIOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "__BaseUpgradeablePausable__init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "__PauserPausable__init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "allowedUIDTypes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assess",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "availableToWithdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "config",
    outputs: [
      {
        internalType: "contract GoldfinchConfig",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "createdAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "creditLine",
    outputs: [
      {
        internalType: "contract ICreditLine",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "depositWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "drawdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "drawdownsPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyShutdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "fundableAt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllowedUIDTypes",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getAmountsOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "interestOwed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "interestAccrued",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "principalOwed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLoanType",
    outputs: [
      {
        internalType: "enum LoanType",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tranche",
        type: "uint256",
      },
    ],
    name: "getTranche",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalDeposited",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalSharePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "interestSharePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lockedUntil",
            type: "uint256",
          },
        ],
        internalType: "struct ITranchedPool.TrancheInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVersion",
    outputs: [
      {
        internalType: "uint8[3]",
        name: "version",
        type: "uint8[3]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "hasAllowedUID",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_config",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_juniorFeePercent",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestApr",
        type: "uint256",
      },
      {
        internalType: "contract ISchedule",
        name: "_schedule",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_lateFeeApr",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fundableAt",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_allowedUIDTypes",
        type: "uint256[]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fundableAt",
        type: "uint256",
      },
    ],
    name: "initializeNextSlice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "juniorFeePercent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lockJuniorCapital",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "numSlices",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseDrawdowns",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "pay",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "owedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accruedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "additionalBalancePayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymentRemaining",
            type: "uint256",
          },
        ],
        internalType: "struct ILoan.PaymentAllocation",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "principalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "interestAmount",
        type: "uint256",
      },
    ],
    name: "pay",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "owedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accruedInterestPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalPayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "additionalBalancePayment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymentRemaining",
            type: "uint256",
          },
        ],
        internalType: "struct ILoan.PaymentAllocation",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "poolSlices",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "principalDeposited",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "principalSharePrice",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "interestSharePrice",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "lockedUntil",
                type: "uint256",
              },
            ],
            internalType: "struct ITranchedPool.TrancheInfo",
            name: "seniorTranche",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "id",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "principalDeposited",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "principalSharePrice",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "interestSharePrice",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "lockedUntil",
                type: "uint256",
              },
            ],
            internalType: "struct ITranchedPool.TrancheInfo",
            name: "juniorTranche",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalInterestAccrued",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "principalDeployed",
            type: "uint256",
          },
        ],
        internalType: "struct ITranchedPool.PoolSlice",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "setAllowedUIDTypes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFundableAt",
        type: "uint256",
      },
    ],
    name: "setFundableAt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newAmount",
        type: "uint256",
      },
    ],
    name: "setLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newAmount",
        type: "uint256",
      },
    ],
    name: "setMaxLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDeployed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalJuniorDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseDrawdowns",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawMax",
    outputs: [
      {
        internalType: "uint256",
        name: "interestWithdrawn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "principalWithdrawn",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "withdrawMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type TranchedPoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TranchedPoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TranchedPool__factory extends ContractFactory {
  constructor(...args: TranchedPoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TranchedPool> {
    return super.deploy(overrides || {}) as Promise<TranchedPool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TranchedPool {
    return super.attach(address) as TranchedPool;
  }
  override connect(signer: Signer): TranchedPool__factory {
    return super.connect(signer) as TranchedPool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TranchedPoolInterface {
    return new utils.Interface(_abi) as TranchedPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TranchedPool {
    return new Contract(address, _abi, signerOrProvider) as TranchedPool;
  }
}
